<script>
    export let isOpen = false;
</script>
<div class="hamburglar is-open" class:is-closed={!isOpen}>
  <div class="burger-icon">
    <div class="burger-container">
      <span class="burger-bun-top"></span>
      <span class="burger-filling"></span>
      <span class="burger-bun-bot"></span>
    </div>
  </div>
</div>

<style>
  .hamburglar {
    transform: scale(1);
    position: relative;
    display: block;
    width: 4rem;
    height: 4rem;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  @-webkit-keyframes rotate-out {
    0% {
      transform: rotate(0deg);
    }
    40% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes rotate-out {
    0% {
      transform: rotate(0deg);
    }
    40% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes rotate-in {
    0% {
      transform: rotate(360deg);
    }
    40% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  @keyframes rotate-in {
    0% {
      transform: rotate(360deg);
    }
    40% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  @-webkit-keyframes dash-in {
    0% {
      stroke-dashoffset: 240;
    }
    40% {
      stroke-dashoffset: 240;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes dash-in {
    0% {
      stroke-dashoffset: 240;
    }
    40% {
      stroke-dashoffset: 240;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @-webkit-keyframes dash-out {
    0% {
      stroke-dashoffset: 0;
    }
    40% {
      stroke-dashoffset: 240;
    }
    100% {
      stroke-dashoffset: 240;
    }
  }
  @keyframes dash-out {
    0% {
      stroke-dashoffset: 0;
    }
    40% {
      stroke-dashoffset: 240;
    }
    100% {
      stroke-dashoffset: 240;
    }
  }
  .burger-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 3rem;
    width: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .burger-container {
    position: relative;
    height: 2.5rem;
    width: 3.2rem;
  }
  .burger-bun-top,
  .burger-bun-bot,
  .burger-filling {
    position: absolute;
    display: block;
    height: 0.3rem;
    width: 3.2rem;
    border-radius: 2px;
    background: var(--global);
  }
  .burger-bun-top {
    top: 0;
    transform-origin: 3.1rem 0.15rem;
  }
  .burger-bun-bot {
    bottom: 0;
    transform-origin: 3.2rem 0.15rem;
  }
  .burger-filling {
    top: 1.1rem;
  }
  .hamburglar.is-open .burger-bun-top {
    -webkit-animation: bun-top-out 0.6s linear normal;
    animation: bun-top-out 0.6s linear normal;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  .hamburglar.is-open .burger-bun-bot {
    -webkit-animation: bun-bot-out 0.6s linear normal;
    animation: bun-bot-out 0.6s linear normal;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  .hamburglar.is-closed .burger-bun-top {
    -webkit-animation: bun-top-in 0.6s linear normal;
    animation: bun-top-in 0.6s linear normal;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  .hamburglar.is-closed .burger-bun-bot {
    -webkit-animation: bun-bot-in 0.6s linear normal;
    animation: bun-bot-in 0.6s linear normal;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  @-webkit-keyframes bun-top-out {
    0% {
      left: 0;
      top: 0;
      transform: rotate(0deg);
    }
    20% {
      left: 0;
      top: 0;
      transform: rotate(15deg);
    }
    80% {
      left: -5px;
      top: 0;
      transform: rotate(-60deg);
    }
    100% {
      left: -5px;
      top: 1px;
      transform: rotate(-45deg);
    }
 
  }
  @keyframes bun-top-out {
    0% {
      left: 0;
      top: 0;
      transform: rotate(0deg);
    }
    20% {
      left: 0;
      top: 0;
      transform: rotate(15deg);
    }
    80% {
      left: -5px;
      top: 0;
      transform: rotate(-60deg);
    }
    100% {
      left: -5px;
      top: 1px;
      transform: rotate(-45deg);
    }
  }
  @-webkit-keyframes bun-bot-out {
    0% {
      left: 0;
      transform: rotate(0deg);
    }
    20% {
      left: 0;
      transform: rotate(-15deg);
    }
    80% {
      left: -5px;
      transform: rotate(60deg);
    }
    100% {
      left: -5px;
      transform: rotate(45deg);
    }
  }
  @keyframes bun-bot-out {
    0% {
      left: 0;
      transform: rotate(0deg);
    }
    20% {
      left: 0;
      transform: rotate(-15deg);
    }
    80% {
      left: -5px;
      transform: rotate(60deg);
    }
    100% {
      left: -5px;
      transform: rotate(45deg);
    }
  }
  @-webkit-keyframes bun-top-in {
    0% {
      left: -5px;
      bot: 0;
      transform: rotate(-45deg);
    }
    20% {
      left: -5px;
      bot: 0;
      transform: rotate(-60deg);
    }
    80% {
      left: 0;
      bot: 0;
      transform: rotate(15deg);
    }
    100% {
      left: 0;
      bot: 1px;
      transform: rotate(0deg);
    }
  }
  @keyframes bun-top-in {
    0% {
      left: -5px;
      bot: 0;
      transform: rotate(-45deg);
    }
    20% {
      left: -5px;
      bot: 0;
      transform: rotate(-60deg);
    }
    80% {
      left: 0;
      bot: 0;
      transform: rotate(15deg);
    }
    100% {
      left: 0;
      bot: 1px;
      transform: rotate(0deg);
    }
  }
  @-webkit-keyframes bun-bot-in {
    0% {
      left: -5px;
      transform: rotate(45deg);
    }
    20% {
      left: -5px;
      bot: 0;
      transform: rotate(60deg);
    }
    80% {
      left: 0;
      bot: 0;
      transform: rotate(-15deg);
    }
    100% {
      left: 0;
      transform: rotate(0deg);
    }
  }
  @keyframes bun-bot-in {
    0% {
      left: -5px;
      transform: rotate(45deg);
    }
    20% {
      left: -5px;
      bot: 0;
      transform: rotate(60deg);
    }
    80% {
      left: 0;
      bot: 0;
      transform: rotate(-15deg);
    }
    100% {
      left: 0;
      transform: rotate(0deg);
    }
  }
  .hamburglar.is-open .burger-filling {
    -webkit-animation: burger-fill-out 0.6s linear normal;
    animation: burger-fill-out 0.6s linear normal;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  .hamburglar.is-closed .burger-filling {
    -webkit-animation: burger-fill-in 0.6s linear normal;
    animation: burger-fill-in 0.6s linear normal;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  @-webkit-keyframes burger-fill-in {
    0% {
      width: 0;
      left: 3.2rem;
    }
    40% {
      width: 0;
      left: 4rem;
    }
    80% {
      width: 3.2rem;
      left: -6px;
    }
    100% {
      width: 3.2rem;
      left: 0px;
    }
  }
  @keyframes burger-fill-in {
    0% {
      width: 0;
      left: 3.2rem;
    }
    40% {
      width: 0;
      left: 4rem;
    }
    80% {
      width: 3.2rem;
      left: -6px;
    }
    100% {
      width: 3.2rem;
      left: 0px;
    }

  }
  @-webkit-keyframes burger-fill-out {
    0% {
      width: 3.2rem;
      left: 0px;
    }
    20% {
      width: 4.2rem;
      left: -6px;
    }
    40% {
      width: 0;
      left: 40px;
    }
    100% {
      width: 0;
      left: 3.2rem;
    }
  }
  @keyframes burger-fill-out {
    0% {
      width: 3.2rem;
      left: 0px;
    }
    20% {
      width: 4.2rem;
      left: -6px;
    }
    40% {
      width: 0;
      left: 40px;
    }
    100% {
      width: 0;
      left: 3.2rem;
    }
  }
</style>
